/*
 * @Author: zjw
 * @Date: 2021-06-10 15:46:35
 * @LastEditTime: 2024-03-07 16:59:22
 * @FilePath: \web-app\src\network\content\artice.js
 * @Environment: Vue + Element
 * @Description: 文章管理
 */
import {
    request,
} from '../request.js'

// 文档列表
export function articeList(data) {
    return request({
        url: '/web/back/sys/doc/list',
        method: 'post',
        data
    })
}

// 添加
export function addArtice(data) {
    return request({
        url: '/web/back/sys/doc/insert',
        method: 'post',
        data
    })
}

// 修改
export function editArtice(data) {
    return request({
        url: '/web/back/sys/doc/update',
        method: 'post',
        data
    })
}
//文章详情
export function articeDetails(params) {
	return request({
		url: "/web/back/sys/doc/doc/detailHtmlMd",
		method: "get",
		params,
	});
}
// 删除
export function delArtice(data) {
    return request({
        url: '/web/back/sys/doc/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelArtice(data) {
    return request({
        url: '/web/back/sys/doc/batch/delete',
        method: 'delete',
        data
    })
}

// 详情
export function detailArtice(data) {
    return request({
        url: '/web/back/sys/doc/' + data,
        method: 'get',
    })
}

// 发布文章
export function releaseArtice(data) {
    return request({
        url: '/web/back/sys/doc/shelf',
        method: 'post',
        data
    })
}

// 上一页
export function previousPage(data) {
    return request({
        url: '/web/back/sys/doc/docPreviousPage',
        method: 'get',
        params: data
    })
}

// 下一页
export function nextPage(data) {
    return request({
        url: '/web/back/sys/doc/docNextPage',
        method: 'get',
        params: data
    })
}

// 文章撤回
export function docRecall(data) {
    return request({
        url: '/web/back/sys/doc/docRecall',
        method: 'get',
        params: data
    })
}

// 文章详情
export function articleDetail(data) {
    return request({
        url: '/web/back/home/doc/detail',
        method: 'get',
        params: data
    })
}

//获取安天上架需要的参数
export function subCatAndIntelabel() {
    return request({
        url: '/web/antiySub/subCatAndIntelabel',
        method: 'get',
    })
}

// 上架 后台生成pdf传给安天
export function addSubIntelligence(data) {
    return request({
        url: '/web/antiySub/addSubIntelligence',
        method: 'post',
        data
    })
}


// 审核
export function docExamine(data) {
    return request({
        url: '/web/back/sys/doc/docExamine',
        method: 'get',
        params:data
    })
}

